export const EXERCISE_QUIZ = 'exercise-quiz'; // a wrapper
export const EXERCISE_QUIZ_QUESTIONS = 'exercise-quiz-questions'; // to navigate, create quiz

export type EditorExerciseOptions = {
  isReadOnly?: boolean;
  onBackWhenInComplete?: () => void;
  preparePayload?: () => void;
  findBellowByType?: (element, type) => void;
  progressList?: {
    exerciseId?: string;
    type?: string;
    userAnswers?: {
      question?: string;
      questionId?: string;
      answerId?: string;
      answerIds?: string[];
    }[];
  }[];
  color?: 'primary' | 'blue' | 'dark' | 'neutral' | 'light' | 'green' | 'red' | 'purple';
  onUpdateUserAnswerByQuestionId?: (userAnswer, questionId, isSingleAnswer) => void;
  onCheckAnswer?: (payload) => void;
  onNeedToSignIn?: () => void;
};

//
/**
 * to input a quiz - complex fields
 * - field title/children[0]: to input question title
 * - field quizType: text/image/audio
 *
 * ///
 * - field textOptions: ({ id: string, text: string })[]
 * - field imageOptions: ({ id: string, image: FileUploadObject; text: string })[]
 * - field audioOptions: ({ id: string, text: string, audioType: "GOOGLE" | "UPLOAD", audio: FileUploadObject })[]
 * => merge to 1 field options: ({
 *      id: string,
 *      text: string,
 *      imageFile: FileUploadObject,
 *      imageText: string,
 *      audioFile: FileUploadObject
 *      audioType: 'GOOGLE' | 'UPLOAD'
 *      audioText: string
 *  })[]
 * ///
 *
 * - field correctAnswers: id of option - will be reset to null if quizType change
 */
export const EXERCISE_QUIZ_QUESTION = 'exercise-quiz-question';

export const ExerciseQuizSupportTypeEnum = {
  TEXT: 'text',
  IMAGE: 'image',
  AUDIO: 'audio',
} as const;

export type ExerciseQuizSupportTypeEnum = typeof ExerciseQuizSupportTypeEnum[keyof typeof ExerciseQuizSupportTypeEnum];
